import * as React from "react";
import { FormattedMessage } from "react-intl";
import { CategoryTypeOptions } from "@models/category";
import Search, { SearchInputType } from "@components/custom/Search";

interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
}

const SearchCategoriesComponent: React.FC<SearchInputProps> = props => {
  const { search } = props;

  const inputs = [
    {
      name: "query",
      label: <FormattedMessage id="app.title" defaultMessage={`Title`} />,
      type: SearchInputType.TEXT,
      size: 8
    },
    {
      name: "type",
      label: <FormattedMessage id="app.type" defaultMessage={`Type`} />,
      type: SearchInputType.SELECT,
      options: CategoryTypeOptions,
      size: 8
    },
  ];

  return <Search inputs={inputs} search={search} />;
};

export default SearchCategoriesComponent;
